//-================ IMPORTS FOR GENERAL COMPONENT ================-\\
import { Component, ElementRef, OnInit, ViewChild, inject } from '@angular/core';
import { firstValueFrom } from 'rxjs';


//-================ IMPORTS FOR SERVICES ================-\\
import { PermisionsFolderService } from 'src/app/Services/Global/Permissions/permisions-folder.service';
import { LibraryFINService } from 'src/app/Services/Libraries/General-FIN/library-fin.service';
import { GeneralCDMSService } from 'src/app/Services/Global/GeneralCDMS/general-cdms.service';


//-================ IMPORTS FOR CONSTANTS ================-\\
import { Icon_Image } from 'src/app/Constants/Constants-Global/Images-Icon';


//-================ IMPORTS FOR DEPENDENCIES ================-\\
import Swal from 'sweetalert2';


//-================ IMPORTS FOR INTERFACES ================-\\
import { Download_CPP } from 'src/app/Interfaces/Libraries/Library-CCP-Int/Download_ALL_Files.interface';
import { Response_GeneralCDMS } from 'src/app/Interfaces/GeneralCDMS/Response_GeneralCDMS.interface';
import { Create_Manual, Manual } from 'src/app/Interfaces/GeneralCDMS/Create_Manual.interface';
import { FILE_CAP } from 'src/app/Interfaces/Libraries/Library-FIN-int/FileCAP.interface';
import { Icon_Images } from 'src/app/Interfaces/Interfaces-Global/Icon_Images.interface';
import { Permission, Permissions } from 'src/app/Constants/Admin/Permissions';
import { GeneralRoleCDMS, typeSystemRoleCDMS } from 'src/app/types/General/RoleCDMS.type';
import { UserDataService } from 'src/app/Services/Authentication/User/user-data.service';


@Component({
    selector: 'app-manual-general-cdms',
    templateUrl: './manual-general-cdms.component.html',
    styleUrls: ['./manual-general-cdms.component.scss', './../../../Styles/GlobalStyles.css'],
    standalone: false
})
export class ManualGeneralCDMSComponent implements OnInit {

  @ViewChild('AddManual')
  MyInputAddManual!: ElementRef;

  //+================== VARIABLES BAND FOR UPDATE OR NEW LOAD ==================+\\
  public IsUpdate: boolean = false;


  //+================== VARIABLES GLOBAL FILES MANUAL ==================+\\
  public All_Manuals: Manual[] = [];


  //+================== VARIABLE ROLES GENERAL ==================+\\
  public RolesGeneral: typeSystemRoleCDMS = GeneralRoleCDMS;

  //+================== VARIABLES FOR LOAD PAGE ==================+\\
  public LoadPage: boolean = false;


  //+================== VARIABLES FILES ==================+\\
  public FileAuxAddManual: FILE_CAP = { FileData: null, FileName: '' };
  public Manual_Selected: Manual = {
    ID: 0,
    ID_Contributor: 0,
    Name: '',
    Extension: '',
    Status: 0,
    ID_Next_Version: 0,
    ID_Previous_Version: 0,
    Upload_Date: null,
  }

  //+================== VARIABLES FOR ICONS IMAGE ==================+\\
  public Icons_Image: Icon_Images[] = Icon_Image;


  //+================== VARIABLES FOR COLOR SWETALERT ==================+\\
  private ColorConfirm: string = '#20a8e1';
  private ColorsCancel: string = '#fc6161';


  //-========================= SERVICES =========================-\\
  public UserService = inject(UserDataService);
  private Service_GeneralCDMS = inject(GeneralCDMSService);
  private PermissionFolder = inject(PermisionsFolderService);
  private Service_FIN = inject(LibraryFINService); // FOR DOWNLOAD FILES

  constructor() { }

  ngOnInit(): void {
    this.Load_Component();
  }
  //&===================== FUNCTIONS FOR LOAD COMPONENT =====================&\\

  //-================== FUNCTION FOR LOAD COMPONENT ==================-\\
  private async Load_Component(): Promise<void> {
    this.LoadPage = false;
    const Loader = document.getElementById('Loader') as HTMLDivElement;
    Loader.classList.add('active');

    try {
      await this.Load_All_Manuals();

      Loader.classList.remove('active');
      this.LoadPage = true;
    } catch (e) {
      Swal.fire({
        title: 'Ocurrió un error (Manuales)',
        text: '¡Recargue la página, si el problema persiste notifique a supervisor!',
        icon: 'warning',
        confirmButtonColor: this.ColorConfirm
      }); Loader.classList.remove('active');
    }
  }

  //-================== FUNCTION FOR LOAD MANUALS ==================-\\
  private async Load_All_Manuals(): Promise<boolean> {
    try {

      const Response_Manual: Response_GeneralCDMS = await firstValueFrom(this.Service_GeneralCDMS.Get_Manuals_CDMS());

      if (Response_Manual.success) {
        this.All_Manuals = Response_Manual.operation;
      }

      return true;
    } catch (e) {
      Swal.fire({
        title: 'Ocurrió un error (Manuales)',
        text: '¡Recargue la página, si el problema persiste notifique a supervisor!',
        icon: 'warning',
        confirmButtonColor: this.ColorConfirm
      });
      return true;
    }
  }


  //&===================== END FUNCTIONS FOR LOAD COMPONENT =====================&\\




  //&===================== FUNCTIONS FOR GENERAL COMPONENT =====================&\\

  //-================== FUNCTTION RETURN CLASS FILE ==================-\\
  public Type_Extension_Class(Extension: string): string {
    return this.Icons_Image.find(item => item.Extension.toLowerCase() === Extension.toLowerCase())?.Class || 'not-found';
  }

  //-================== FUNCTTION FOR RETURN URL IMAGE ==================-\\
  public Type_Extension_Img(Extension: string): string {
    return this.Icons_Image.find(item => item.Extension.toLowerCase() === Extension.toLowerCase())?.Url_Image.toLowerCase() || 'not-found.png';
  }

  //-================== FUNCTTION FOR VERIFICATE IF UPDATE OR NEW MODAL ==================-\\
  public OpenModalIsUpdate(IsUpdate: boolean, Manual: Manual | null): void {
    this.IsUpdate = IsUpdate;
    if (Manual !== null) this.Manual_Selected = Manual;

    this.ToggleModalAddManual(true);
  }

  //-================ FUNCTION FOR NAME USER ================-\\
  public NameUser(): string {
    const Name_User: string = localStorage.getItem('Name_User') || "";
    return (Name_User.split(' ', 2)).join(' ');
  }

  public Cut_Name(NameManual: string): string {

    let NameManual_List = NameManual.split('.');
    NameManual_List.pop();

    const Name_Clen: string = NameManual_List.join('.');

    return Name_Clen.length > 40 ? Name_Clen.slice(0, 40) + '...' : Name_Clen;

  }

  //&===================== END FUNCTIONS FOR GENERAL COMPONENT =====================&\\




  //&===================== FUNCTIONS FOR SEND AND UPDATE MANUAL =====================&\\

  //-================== FUNCTTION OPEN OR CLOSE MODAL ADD MANUAL ==================-\\
  public ToggleModalAddManual(CloseOrOpen: boolean): void {
    const ModalAddManual = document.getElementById('ModalAddManual') as HTMLElement;
    CloseOrOpen ? ModalAddManual.classList.add('active') : ModalAddManual.classList.remove('active');
  }

  //-================== FUNCTION FOR ADD CLASS HOVER INPUT FILE ==================-\\
  public Load_File(): void {
    const Drag_Drop = document.getElementById('Drag-Drop') as HTMLDivElement;
    Drag_Drop.classList.add('active');
  }

  //-================== FUNCTION FOR REMOVE CLASS HOVER INPUT FILE ==================-\\
  public Onload_File(): void {
    const Drag_Drop = document.getElementById('Drag-Drop') as HTMLDivElement;
    Drag_Drop.classList.remove('active');
  }

  //-================== FUNCTION TO CAPTURE FILE UPLOAD (MANUAL) ==================-\\
  public Load_Document_Manual(data: Event): void {
    const Target = data.target as HTMLInputElement;
    let file: File = (Target.files as FileList)[0];

    if (file) {
      this.FileAuxAddManual = {
        FileData: file,
        FileName: file.name
      }


      !this.IsUpdate ? this.Send_Manual() : this.Send_Update_Manual();

    }
    this.Onload_File();
    this.MyInputAddManual.nativeElement.value = null;
  }

  //-================== FUNCTION FOR SEND NEW MANUAL ==================-\\
  private Send_Manual(): void {

    const Create_Manual: Create_Manual = {
      Name: this.FileAuxAddManual.FileName,
      Extension: this.FileAuxAddManual.FileName.split('.').pop() || '',
      Status: 1,
      ID_Previous_Version: null,
    }

    Swal.fire({
      title: '¿Está seguro de cargar este manual?',
      text: `¡El nombre del manual es ${this.FileAuxAddManual.FileName}!`,
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: this.ColorConfirm,
      cancelButtonColor: this.ColorsCancel,
      confirmButtonText: 'Si, Cargar manual!'
    }).then(async (result) => {

      if (result.isConfirmed) {
        this.Animation_Modal_Manual(true);

        const Container_Progress_Manual = document.getElementById('Container-Progress-Manual') as HTMLDivElement;
        Container_Progress_Manual.classList.add('active');

        setTimeout(async () => {

          try {

            const ResManual: Response_GeneralCDMS = await firstValueFrom(this.Service_GeneralCDMS.Upload_Manual(Create_Manual));

            if (ResManual.success) {
              const Manual: Manual = ResManual.operation;

              await this.Send_File_Modal(Manual);

              Container_Progress_Manual.classList.remove('active');
              this.Animation_Modal_Manual(false);
              this.ToggleModalAddManual(false);
              this.Load_Component();

              Swal.fire({
                icon: 'success',
                title: 'Manual cargado correctamente',
                confirmButtonColor: this.ColorConfirm
              })

            }

          } catch (e) {

            Swal.fire({
              title: 'Error en el Manual',
              text: '¡No se guardo el Manual en el sistema, informa a tu supervisor!',
              icon: 'warning',
              confirmButtonColor: this.ColorConfirm
            })

            Container_Progress_Manual.classList.remove('active');
            this.Animation_Modal_Manual(false);
            this.ToggleModalAddManual(false);
            this.Load_Component();
          }
        }, 2500);


      }

    })

  }

  //-================== FUNCTION FOR SEND DATA MANUAL ==================-\\
  private Send_File_Modal(Manual: Manual): Promise<boolean> {

    return new Promise((resolve, reject) => {


      const TextProgress = document.getElementById('TextProgress') as HTMLDivElement;
      const Progress_Bar_Manual = document.getElementById('Progress-Bar-Manual') as HTMLDivElement;

      const File = new FormData();

      File.append('File_Manual', this.FileAuxAddManual.FileData, encodeURIComponent(Manual.ID + '.' + Manual.Extension))

      try {

        this.Service_GeneralCDMS.Upload_Manual_File(File).subscribe(async (event: any) => {

          if (event.status === 500) {

            Progress_Bar_Manual.style.width = "0%";
            TextProgress.innerHTML = "0%";
            Swal.fire({
              title: 'Error en el Manual',
              text: '¡Ha ocurrido un error al cargar el Manual, informe al supervisor!',
              icon: 'warning',
              confirmButtonColor: this.ColorConfirm
            })

          }

          if (event['loaded'] && event['total']) {
            let value = (Math.round(event['loaded'] / event['total'] * 100));
            Progress_Bar_Manual.style.width = value + "%";
            TextProgress.innerHTML = value + "%";
          }

          if (event['body']) {
            Progress_Bar_Manual.style.width = "0%";
            TextProgress.innerHTML = "0%";
            resolve(true);
          }

        })

      } catch (e) {
        Swal.fire({
          title: 'Error en el Manual',
          text: '¡No se guardo el Manual en el sistema, informa a tu supervisor!',
          icon: 'warning',
          confirmButtonColor: this.ColorConfirm
        })

        reject(false);
      }

    })

  }

  //-================== FUNCTION FOR SEND MANUAL FILE  ==================-\\
  private Animation_Modal_Manual(DiabledOrEnabled: boolean): void {
    const Pro_popup3 = document.getElementById('Pro-popup3') as HTMLDivElement;
    const Pro_inside3 = document.getElementById('Pro-inside3') as HTMLDivElement;
    const Pro_content3 = document.getElementById('Pro-content3') as HTMLDivElement;
    DiabledOrEnabled ? Pro_popup3.classList.add('active') : Pro_popup3.classList.remove('active');
    DiabledOrEnabled ? Pro_inside3.classList.add('active') : Pro_inside3.classList.remove('active');
    DiabledOrEnabled ? Pro_content3.classList.add('active') : Pro_content3.classList.remove('active');
  }

  //-================== FUNCTION FOR SEND UPDATE MANUAL ==================-\\
  private Send_Update_Manual(): void {

    const Create_Manual: Create_Manual = {
      Name: this.FileAuxAddManual.FileName,
      Extension: this.FileAuxAddManual.FileName.split('.').pop() || '',
      Status: 1,
      ID_Previous_Version: this.Manual_Selected.ID,
    }

    Swal.fire({
      title: '¿Está seguro de actualizar este manual?',
      text: `¡El nombre del manual es ${this.FileAuxAddManual.FileName}!`,
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: this.ColorConfirm,
      cancelButtonColor: this.ColorsCancel,
      confirmButtonText: 'Si, actualizar manual!'
    }).then(async (result) => {

      if (result.isConfirmed) {
        this.Animation_Modal_Manual(true);

        const Container_Progress_Manual = document.getElementById('Container-Progress-Manual') as HTMLDivElement;
        Container_Progress_Manual.classList.add('active');

        setTimeout(async () => {

          try {

            const ResManual: Response_GeneralCDMS = await firstValueFrom(this.Service_GeneralCDMS.Upload_Manual(Create_Manual));

            if (ResManual.success) {
              const Manual: Manual = ResManual.operation;

              await this.Send_File_Modal(Manual);

              Container_Progress_Manual.classList.remove('active');
              this.Animation_Modal_Manual(false);
              this.ToggleModalAddManual(false);
              this.Load_Component();

              Swal.fire({
                icon: 'success',
                title: 'Manual cargado correctamente',
                confirmButtonColor: this.ColorConfirm
              })

            }

          } catch (e) {

            Swal.fire({
              title: 'Error en el Manual',
              text: '¡No se guardo el Manual en el sistema, informa a tu supervisor!',
              icon: 'warning',
              confirmButtonColor: this.ColorConfirm
            })

            Container_Progress_Manual.classList.remove('active');
            this.Animation_Modal_Manual(false);
            this.ToggleModalAddManual(false);
            this.Load_Component();
          }
        }, 2500);


      }

    })

  }

  //&===================== END FUNCTIONS FOR SEND AND UPDATE MANUAL =====================&\\


  //&===================== FUNCTIONS FOR OPTION CARD =====================&\\


  //-============== FUNCTION FOR DOWNLOAD MANUAL ==============\\
  public async Download_Manual(Manual: Manual): Promise<void> {

    try {

      const ResGetURLManual: Response_GeneralCDMS = await firstValueFrom(this.Service_GeneralCDMS.Get_URL_Download_Manual({ ID: Manual.ID }));

      if (ResGetURLManual.success) {

        const URL = ResGetURLManual.operation.URL_Manual;

        const IsDownload = this.Download_File_Manual(URL, Manual.Name);

        if (!IsDownload) throw new Error('No file Download');
      }

    } catch (e) {

      const Toast = Swal.mixin({
        toast: true,
        position: 'top-end',
        showConfirmButton: false,
        timer: 3000,
        timerProgressBar: true,
        didOpen: (toast) => {
          toast.addEventListener('mouseenter', Swal.stopTimer)
          toast.addEventListener('mouseleave', Swal.resumeTimer)
        }
      })

      Toast.fire({
        icon: 'error',
        title: '¡Error al descargar el manual, informa a tu supervisor!'
      })
    }

  }

  private async Download_File_Manual(URL: string, File_Name: string): Promise<boolean> {


    return new Promise((resolve) => {

      const ProgressModal = document.getElementById('ProgressModal') as HTMLDivElement;
      const Progress_Bar_Table = document.getElementById('Progress-Bar-Table') as HTMLElement;
      ProgressModal.classList.add('active');


      this.Service_FIN.Download_File_FIN(URL, File_Name).subscribe((Data_Download: Download_CPP) => {


        if (Data_Download.state === "IN_PROGRESS") {
          Progress_Bar_Table.style.width = Data_Download.progress + '%';
        }

        if (Data_Download.state === "DONE") {

          ProgressModal.classList.remove('active');
          Progress_Bar_Table.style.width = '0%';

          const Toast = Swal.mixin({
            toast: true,
            position: 'top-end',
            showConfirmButton: false,
            timer: 1500,
            timerProgressBar: true,
            didOpen: (toast) => {
              toast.addEventListener('mouseenter', Swal.stopTimer)
              toast.addEventListener('mouseleave', Swal.resumeTimer)
            }
          })

          Toast.fire({
            icon: 'success',
            title: 'Manual descargado!'
          })

          resolve(true)
        }


        if (Data_Download.Status === 404 || Data_Download.Status === 500) {


          const Toast = Swal.mixin({
            toast: true,
            position: 'top-end',
            showConfirmButton: false,
            timer: 3000,
            timerProgressBar: true,
            didOpen: (toast) => {
              toast.addEventListener('mouseenter', Swal.stopTimer)
              toast.addEventListener('mouseleave', Swal.resumeTimer)
            }
          })

          Toast.fire({
            icon: 'error',
            title: '¡Error al descargar el manual, informe a su supervisor!'
          })

          ProgressModal.classList.remove('active');
          Progress_Bar_Table.style.width = '0%';

          resolve(false);
        }

      })
    })

  }

  public Delete_Manual(Manual: Manual): void {

    let NameManual = Manual.Name.split('.');
    NameManual.pop();

    const Name_Clen: string = NameManual.join('.');

    Swal.fire({
      title: 'Eliminar Manual',
      icon: 'warning',
      text: `¿Desea eliminar el manual ${Name_Clen}?`,
      showCancelButton: true,
      confirmButtonColor: this.ColorConfirm,
      cancelButtonColor: this.ColorsCancel,
      confirmButtonText: 'Sí, Eliminar',
      cancelButtonText: 'No, Cancelar',
    }).then((async result => {

      if (result.isConfirmed) {

        Swal.fire({
          title: 'Nuevamente ¿está seguro?',
          text: `¡Para eliminar el manual escriba ${Name_Clen} !`,
          input: 'text',
          confirmButtonText: 'Continuar <i class="fa-solid fa-right-long"></i>',
          confirmButtonColor: this.ColorConfirm,
          cancelButtonColor: this.ColorsCancel,
          showCancelButton: true,
        }).then((async result2 => {

          if (result2.isConfirmed) {

            const ValueInput: string = result2.value;

            if (ValueInput.toLowerCase() === Name_Clen.toLowerCase()) {

              try {

                const ResDelete: Response_GeneralCDMS = await firstValueFrom(this.Service_GeneralCDMS.Delete_Manual_CDMS({ ID: Manual.ID }));

                if (ResDelete.success) {
                  Swal.fire({
                    icon: 'success',
                    title: 'Manual eliminado',
                    text: '¡Se elimino correctamente el manual!',
                    confirmButtonColor: this.ColorConfirm
                  });
                  this.Load_Component();
                }

              } catch (e) {
                Swal.fire({
                  icon: 'warning',
                  title: 'Error al eliminar el manual',
                  text: '¡No se eliminó el manual, notifica a tu supervisor!',
                  confirmButtonColor: this.ColorConfirm
                });
                this.Load_Component();
              }

            } else {
              Swal.fire({
                icon: 'warning',
                title: 'Sin coincidencia',
                text: '¡Escriba correctamente el nombre del manual para eliminarlo!',
                confirmButtonColor: this.ColorConfirm
              })
            }
          }
        }))
      }

    }))
  }

  //&===================== END FUNCTIONS FOR OPTION CARD =====================&\\


}
